import { createContext, useContext } from 'react';

import type { Edition, Product } from '../types';

export interface EditionAwarenessContextType {
	cloudId: string;
	product: Product;
	edition: Edition;
	isInvoiceable?: boolean;
	canAddPaymentDetails?: boolean;
	trialDaysLeft?: number;
	isInTrial?: boolean;
	isInPredunning?: boolean;
	canUpgrade?: boolean;
}

export const EditionAwarenessContext = createContext<EditionAwarenessContextType | null>(null);

export function useEditionAwareness() {
	const context = useContext(EditionAwarenessContext);

	if (!context) {
		throw new Error('Missing context, please ensure this is used within EditionAwarenessContext');
	}

	return context;
}
